import _ from 'lodash';
import {useQuery} from '@tanstack/react-query';
import {invalidateQuery} from './react_query.js';
import api from './api.js';

export const useUser = ()=>{
    let {data, isLoading} = useQuery({
        queryKey: ['user'],
        queryFn: ()=>api.getUser(),
    });
    return [!_.isEmpty(data?.user)&&data.user, isLoading];
};

export const refreshUser = ()=>invalidateQuery(['user']);
